<mat-card-content *ngIf="isLoading" style="display: flex; justify-content: center; align-items: center; height: 60vh;">
  <mat-spinner></mat-spinner>
</mat-card-content>

<div *ngIf="!isLoading">
  <!-- Active session banner -->
  <div class="file-container-wrapper" *ngIf="isAddingToSession">
    <div class="file-container-2 session-active-banner">
      <div class="mat-input-container-2">
        <div class="session-banner-content">
          <mat-icon class="session-icon">layers</mat-icon>
          <div>
            <p class="session-banner-title">Saving to session: <strong>{{ activeSessionName }}</strong></p>
          </div>
        </div>
        <button mat-flat-button color="warn" class="cancel-button-2" (click)="onCancelSessionInsertion()">Cancel</button>
      </div>
    </div>
  </div>
  <!-- No active session banner -->
  <div class="file-container-wrapper" *ngIf="!isAddingToSession">
    <div class="file-container-2">
      <div class="mat-input-container-2">
        <p>Estimated products will <strong>not</strong> be saved to any session.</p>
        <p>Go to <a [routerLink]="'/main/apps/sessions'" role="button">My Sessions</a> to create or select a session.</p>
      </div>
    </div>
  </div>
<br>

<mat-card class="trinta-card all-courses-card mb-25 bg-white border-none d-block">
  <mat-card-content>
    <mat-tab-group animationDuration="0ms" [(selectedIndex)]="selectedTab">
      <mat-tab label="1. Upload product photos" style="font-weight: bold;">
        <div class="button-group">
          <input type="file" accept="image/*" id="fullFileInput" (change)="onFileSelectedFullItemPhoto($event)" hidden>
          <button mat-flat-button color="primary" (click)="openFullFileSelector()" class="upload-photo-button">
            <div class="button-content">
              <span>
                <i-feather *ngIf="!fullProductPhoto" name="camera"></i-feather>
                Capture Product Photo
              </span>
              <mat-icon *ngIf="fullProductPhoto">check_circle</mat-icon>
            </div>
          </button>
    
          <input type="file" accept="image/*" id="labelFileInput" (change)="onFileSelectedLabelPhoto($event)" hidden>
          <button mat-flat-button color="primary" (click)="openLabelFileSelector()" class="upload-photo-button">
            <div class="button-content">
              <span>
                <i-feather *ngIf="!labelPhoto" name="camera"></i-feather>
                Capture Label Photo (optional)
              </span>
              <mat-icon *ngIf="labelPhoto">check_circle</mat-icon>
            </div>
          </button>
        </div>
        <div class="camera-container">
          <div class="photos-container">
            <div class="photo-wrapper">
              <mat-card-content *ngIf="fullProductLoading">
                <mat-spinner [diameter]="60" [strokeWidth]="5"></mat-spinner>
              </mat-card-content>
              <div *ngIf="!fullProductLoading && fullProductPhoto">
                <img [src]="fullProductPhoto" alt="Full product photo" class="captured-photo"/>
                <button
                  mat-stroked-button
                  color="warn"
                  class="remove-button"
                  (click)="removeFullPhoto()"
                  style="border: none;"
                >
                  <mat-icon>delete</mat-icon>
                  Remove
                </button>
              </div>

            </div>

            <div class="photo-wrapper">
              <mat-card-content *ngIf="labelPhotoLoading">
                <mat-spinner [diameter]="60" [strokeWidth]="5"></mat-spinner>
              </mat-card-content>
              <div *ngIf="labelPhoto && !labelPhotoLoading">
                <img [src]="labelPhoto" alt="Product label photo" class="captured-photo"/>
                <button
                  mat-stroked-button
                  color="warn"
                  class="remove-button"
                  (click)="removeLabelPhoto()"
                  style="border: none;"
                >
                <mat-icon>delete</mat-icon>
                  Remove
                </button>
              </div>
              
            </div>
          </div>
        </div>
    
        <div class="camera-container">
          <div class="mat-input-container" style="margin-bottom: 20px;">
            <button mat-flat-button color="primary" (click)="predict()" [disabled]="estimateButtonDisabled"
              style="margin-top: 10px; font-size: 16px;" class="estimate-button">Estimate</button>
          </div>
        </div>
      </mat-tab>

      <mat-tab label="2. Estimations" [disabled]="estimationsTabDisabled" style="font-weight: bold;">
        <div *ngIf="estimationsLoading" style="margin-top: 50px; margin-bottom: 50px;">
          <div style="display: flex; justify-content: center; align-items: center; margin-top: 20px;">
            <mat-progress-bar mode="indeterminate" style="width: 50%;"></mat-progress-bar>
          </div>
        </div>
        <div class="camera-container">
          <div *ngIf="showAlertInfo && !estimationsLoading" class="textareas-container">
            <div class="alert alert-warning" style="max-width: 300px; display: flex; text-align: center; align-content: center; color: rgb(141, 144, 0);">
              {{ alertInfoText }}
            </div>
          </div>
          <div *ngIf="!estimationsLoading" class="tables-wrapper">
            <table class="styled-table">
              <thead>
                <tr>
                  <th style="text-align: center; font-size: 15px;">Info</th>
                  <th style="text-align: center; font-size: 15px;">Predicted value</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Item</td>
                  <td>
                    <span *ngIf="!editingDetails">{{ outputItem }}</span>
                    <textarea style="font-size: 16px;" *ngIf="editingDetails" [(ngModel)]="outputItem"></textarea>
                  </td>
                </tr>
                <tr>
                  <td>Brand</td>
                  <td>
                    <span *ngIf="!editingDetails">{{ outputBrand }}</span>
                    <textarea style="font-size: 16px;" *ngIf="editingDetails" [(ngModel)]="outputBrand"></textarea>
                  </td>
                </tr>
                <tr>
                  <td>Material</td>
                  <td>
                    <span *ngIf="!editingDetails">{{ outputMaterial }}</span>
                    <textarea style="font-size: 16px;" *ngIf="editingDetails" [(ngModel)]="outputMaterial"></textarea>
                  </td>
                </tr>
                <tr>
                  <td>Color/Pattern</td>
                  <td>
                    <span *ngIf="!editingDetails">{{ outputColor }}</span>
                    <textarea style="font-size: 16px;" *ngIf="editingDetails" [(ngModel)]="outputColor"></textarea>
                  </td>
                </tr>
              </tbody>
            </table>
            </div>
            <div *ngIf="!estimationsLoading" class="textareas-container" style="flex-direction: row; margin-bottom: 20px;">
              <button
                mat-flat-button
                color="primary"
                style="background-color: #009879; font-size: 16px;"
                (click)="onEditItemDetails()"
                class="upload-button"
              >
              <mat-icon style="font-size: 16px; vertical-align:middle; margin-right: 3px;">{{editButtonIcon}}</mat-icon>
                {{editDetailsBtnName}}
              </button>
              <button *ngIf="editingDetails"
                mat-flat-button
                color="primary"
                style="background-color: #dd1919; font-size: 16px;"
                (click)="onCancelEditingDetails()"
                class="upload-button"
              >
                Cancel
              </button>
            </div>
            <div *ngIf="!estimationsLoading">
              <div class="condition-container">
                <div class="condition-label">Condition</div>
                <div class="condition-button-group">
                  <button type="button"
                          class="condition-button"
                          [ngClass]="{'selected': condition === 'Excellent'}"
                          (click)="selectCondition('Excellent')">
                    <span *ngIf="condition === 'Excellent'" class="icon">
                    </span>
                    <span class="label">Excellent</span>
                  </button>
    
                  <button type="button"
                          class="condition-button"
                          [ngClass]="{'selected': condition === 'Good'}"
                          (click)="selectCondition('Good')">
                    <span *ngIf="condition === 'Good'" class="icon">
                    </span>
                    <span class="label">Good</span>
                  </button>
    
                  <button type="button"
                          class="condition-button"
                          [ngClass]="{'selected': condition === 'Fair'}"
                          (click)="selectCondition('Fair')">
                    <span *ngIf="condition === 'Fair'" class="icon">
                    </span>
                    <span class="label">Fair</span>
                  </button>
    
                  <button type="button"
                          class="condition-button"
                          [ngClass]="{'selected': condition === 'Flawed'}"
                          (click)="selectCondition('Flawed')">
                    <span *ngIf="condition === 'Flawed'" class="icon">
                    </span>
                    <span class="label">Flawed</span>
                  </button>
                </div>
              </div>
    
              <div class="condition-container">
                <div class="condition-label">Age</div>
                <div class="condition-button-group">
                  <button type="button"
                          class="condition-button"
                          [ngClass]="{'selected': age === 'Current'}"
                          (click)="selectAge('Current')">
                    <span *ngIf="age === 'Current'" class="icon">
                    </span>
                    <span class="label">Current</span>
                  </button>
    
                  <button type="button"
                          class="condition-button"
                          [ngClass]="{'selected': age === 'Off-Trend'}"
                          (click)="selectAge('Off-Trend')">
                    <span *ngIf="age === 'Off-Trend'" class="icon">
                    </span>
                    <span class="label">Off-Trend</span>
                  </button>
    
                  <button type="button"
                          class="condition-button"
                          [ngClass]="{'selected': age === 'Vintage'}"
                          (click)="selectAge('Vintage')">
                    <span *ngIf="age === 'Vintage'" class="icon">
                    </span>
                    <span class="label">Vintage</span>
                  </button>
                </div>
              </div>
            </div>
        </div>
    
        <div *ngIf="!estimationsLoading" class="textareas-container" style="flex-direction: row; margin-bottom: 20px;">
          <button
            mat-flat-button
            color="primary"
            style="font-size: 16px;"
            (click)="getPrice()"
            class="get-price-button"
          >
            Get Price
          </button>
        </div>
      </mat-tab>
      <mat-tab label="3. Pricing" [disabled]="pricingTabDisabled" style="font-weight: bold;">
        <div *ngIf="pricingLoading" style="margin-top: 50px; margin-bottom: 50px;">
          <div style="display: flex; justify-content: center; align-items: center; margin-top: 20px;">
            <mat-progress-bar mode="indeterminate" style="width: 50%;"></mat-progress-bar>
          </div>
        </div>
        <div class="camera-container" *ngIf="!pricingLoading">
          <div *ngIf="showAlertInfoPricing" class="textareas-container">
            <div class="alert alert-warning" style="max-width: 300px; display: flex; text-align: center; align-content: center; color: rgb(141, 144, 0);">
              {{ alertInfoTextPricing }}
            </div>
          </div>
          <div class="wrapper">
            <div class="price-prediction-container" *ngIf="predictionMade">
              <div class="mat-input-container">
                <label *ngIf="editingPrice" for="predictedPriceInput" style="display: flex; align-items: start; font-weight: bold;">Price</label>
                <input *ngIf="editingPrice"
                 id="predictedPriceInput"
                 (input)="priceOnChange()"
                 name="predictedPriceInput"
                 type="number"
                 step="1"
                 class="mat-input"
                 style="text-align: center; font-size: 16px;"
                 [(ngModel)]="price">
                <span *ngIf="!editingPrice" style="font-weight: normal; font-size: medium;">Estimated price:&nbsp; </span>
                <span *ngIf="!editingPrice" style="font-weight: bold; font-size: large;">${{price}}</span>
              </div>
            </div>
            <div class="price-update-container" *ngIf="predictionMade">
              <div class="mat-input-container">
                <span style="font-weight: normal; font-size: small;">{{priceNotAccurateMessage}}&nbsp; </span>
                <div class="row-btn-container">
                  <div class="mat-input-container">
                    <button mat-flat-button color="primary" [disabled]="updateBtnDisabled" (click)="editPrice()" class="update-btn">{{updateBtnName}}</button>
                  </div>
                  <div *ngIf="editingPrice" class="mat-input-container">
                    <button mat-flat-button color="secondary" (click)="cancelUpdate()" class="update-btn">Cancel</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="camera-container" *ngIf="!pricingLoading && !updateLoading">
          <div *ngIf="!updateLoading" class="mat-input-container" style="margin-bottom: 10px;">
            <button mat-flat-button color="primary" (click)="continueAndUpdateModels()" [disabled]="submitDisabled"
              style="margin-top: 10px; font-size: 16px;" class="estimate-button">{{updatePriceForProductBtnName}}</button>
          </div>
        </div>

        <div class="camera-container">
          <div *ngIf="showSuccessInfo && !pricingLoading && !updateLoading" class="mat-input-container">
            <div class="info-text" style="max-width: 300px; display: flex; text-align: center; align-content: center;">
              {{successInfoText}}
            </div>
          </div>
        </div>

        <div *ngIf="!pricingLoading && !updateLoading" class="camera-container" style="margin-top: 5px;">
          <button
            mat-stroked-button
            color="accent"
            class="start-button"
            (click)="startAgain()"
            style="border: none;"
          >
            <mat-icon>arrow_back</mat-icon>
            Start again
          </button>
        </div>
        <div *ngIf="updateLoading" style="margin-top: 50px; margin-bottom: 50px;">
          <div style="display: flex; justify-content: center; align-items: center; margin-top: 20px;">
            <mat-progress-bar mode="indeterminate" style="width: 50%;"></mat-progress-bar>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </mat-card-content>
</mat-card>

</div>
